import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: any;
  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<void> {
    try {
      this.config = await firstValueFrom(
        this.http.get('/config/config.json')
      );
      console.log('Loaded config.json', this.config);
    } catch (error) {
      console.error('Failed to load config.json', error);
      this.config = {};
    }
  }

  getConfig(): any {
    return this.config;
  }

  getValue<T = any>(key: string): T {
    return this.config?.[key];
  }

  async getImageUrl(fileName: string): Promise<Blob> {
    try {
      const response = await firstValueFrom(
        this.http.get(`/config/images/${fileName}`, {
          responseType: 'blob'
        })
      );

      return response;
    } catch (error) {
      return new Blob();
    }
  }
}
